import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const itemStatusListSlice = createSlice({
  name: "itemStatusListSlice",
  initialState,
  //REDUCER
  reducers: {
    setItemStatusList(state, action) {
      return {
        ...state,
        rows:  action.payload,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    addStatus(state, action) {
      return {
        ...state,
        rows: [...state.rows, action.payload],
      };
    },
    editStatus(state, action) {
      return {
        ...state,
        rows: state.rows.map((row) =>
          row.id === action.payload.id ? action.payload : row
        ),
      };
    },
    deleteStatus(state, action) {
      return {
        ...state,
        rows: state.rows.filter((row) => row.id !== action.payload),
      };
    },
  },
});

//ACTIONS
export const {
    setItemStatusList,
    showLoading,
    hideLoading,
    addStatus,
    editStatus,
    deleteStatus,
} = itemStatusListSlice.actions;

export default itemStatusListSlice.reducer;
